(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-rating"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var link = event.target.closest('a.product__rating-count-potential-link, a[href*="#shopify-product-reviews"]');
    if (!link) return;

    var target =
      document.querySelector('#shopify-product-reviews') ||
      document.querySelector('#klaviyo-product-reviews-wrapper') ||
      document.querySelector('[id*="klaviyo_reviews"]') ||
      document.querySelector('[id*="klaviyo-reviews"]') ||
      document.querySelector('.klaviyo-reviews');

    if (!target) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sibling-swatch"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__sohaSiblingCardImages) return;
    window.__sohaSiblingCardImages = true;

    function cardImages(item) {
      return item ? item.querySelectorAll('.product-item__media .image__img') : [];
    }

    function rememberOriginal(img) {
      if (img.dataset.originalSrc != null) return;
      img.dataset.originalSrc = img.getAttribute('src') || '';
      img.dataset.originalSrcset = img.getAttribute('srcset') || '';
      img.dataset.originalSizes = img.getAttribute('sizes') || '';
    }

    function applyImage(img, url) {
      rememberOriginal(img);
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = url;
    }

    function restoreImage(img) {
      if (!img || img.dataset.originalSrc == null) return;
      img.src = img.dataset.originalSrc;
      if (img.dataset.originalSrcset) {
        img.setAttribute('srcset', img.dataset.originalSrcset);
      } else {
        img.removeAttribute('srcset');
      }
      if (img.dataset.originalSizes) {
        img.setAttribute('sizes', img.dataset.originalSizes);
      } else {
        img.removeAttribute('sizes');
      }
    }

    document.addEventListener(
      'pointerenter',
      function (event) {
        var swatch = event.target.closest('[data-product-item-sibling-swatch]');
        if (!swatch || !swatch.dataset.featuredImage) return;
        var item = swatch.closest('.product-item');
        cardImages(item).forEach(function (img) {
          applyImage(img, swatch.dataset.featuredImage);
        });
      },
      true
    );

    document.addEventListener(
      'pointerout',
      function (event) {
        var item = event.target.closest('.product-item');
        if (!item) return;
        if (event.relatedTarget && item.contains(event.relatedTarget)) return;
        cardImages(item).forEach(restoreImage);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
